module.exports = __webpack_public_path__ + "static/media/vesicula_avancada.808a04d4.jpeg";